import React from 'react';
import { Checkbox, Card, CardContent, Button, Typography, CardHeader, Stack } from '@mui/material';


export const AlertDetails = ({ handleSubmit, title, content, loading }) => {
  const [markAsRead, setMarkAsRead] = React.useState(false);

  return (
    <Card>
      <CardHeader title={title} />
      <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="body1" textAlign="center">
          {content}
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%" sx={{ mt: 5 }}>
          <Checkbox name="send_email" checked={markAsRead} onChange={() => setMarkAsRead(!markAsRead)}/>
          <Typography variant="subtitle2">Oznacz jako przeczytane</Typography>
        </Stack>
        <Button sx={{ flexGrow: 0.4, mt: 1 }} variant="outlined" disabled={loading} onClick={() => handleSubmit(markAsRead)}>Zamknij</Button>
      </CardContent>
    </Card>
  );
};
